import { translate } from '@utils/i18n';
import { IKeyValueType } from '@components/v2/KeyValueList';
import { namespace as proposalNamespace } from '../constants';
const namespace = `${proposalNamespace}.fields`;
export default function getGeneralInfo(proposal) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const formatCurrency = (amount) => {
        if (amount === undefined || amount === null)
            return '$0.00';
        return `$${amount.toFixed(2)}`;
    };
    const formatGrossMargin = (margin, subTotal) => {
        if (!subTotal)
            return `${formatCurrency(margin)} (—)`;
        const percentage = (margin / subTotal) * 100;
        return `${formatCurrency(margin)} (${percentage.toFixed(2)}%)`;
    };
    return {
        group1: [
            {
                key: translate('project_name', { namespace }),
                value: (_a = proposal.projectName) !== null && _a !== void 0 ? _a : '',
                type: IKeyValueType.text,
                editable: true,
                field: 'projectName'
            },
            {
                key: translate('proposal_number', { namespace }),
                value: (_b = proposal.proposalNumber) !== null && _b !== void 0 ? _b : '',
                type: IKeyValueType.text,
                editable: true,
                field: 'proposalNumber'
            },
            {
                key: translate('proposal_date', { namespace }),
                value: (_c = proposal.proposalDate) !== null && _c !== void 0 ? _c : '',
                editable: true,
                type: IKeyValueType.date,
                field: 'proposalDate'
            },
            ((_d = proposal.building) === null || _d === void 0 ? void 0 : _d.address)
                ? {
                    key: translate('address', { namespace }),
                    value: proposal.building.address,
                    type: IKeyValueType.address
                }
                : undefined,
            proposal.po
                ? {
                    key: translate('po', { namespace }),
                    value: proposal.po,
                    type: IKeyValueType.text,
                    editable: true,
                    field: 'po'
                }
                : undefined
        ].filter(Boolean),
        group2: [
            !proposal.enableTaxGroups
                ? {
                    key: `${translate('tax_rate', { namespace })} (%)`,
                    value: proposal.salesTax,
                    type: IKeyValueType.number,
                    editable: true,
                    allowDecimals: true,
                    allowNegative: false,
                    field: 'salesTax'
                }
                : undefined,
            proposal.cost !== undefined && proposal.showProfitMargin
                ? {
                    key: translate('cost', { namespace }),
                    value: formatCurrency(proposal.cost),
                    type: IKeyValueType.text
                }
                : undefined,
            proposal.grossMargin !== undefined && proposal.subTotal !== undefined && proposal.showProfitMargin
                ? {
                    key: translate('gross_margin', { namespace }),
                    value: formatGrossMargin(proposal.grossMargin, proposal.subTotal),
                    type: IKeyValueType.text
                }
                : undefined,
            proposal.subTotal !== undefined
                ? {
                    key: translate('sub_total', { namespace }),
                    value: formatCurrency(proposal.subTotal),
                    type: IKeyValueType.text
                }
                : undefined,
            proposal.subTotal && ((proposal.enableTaxGroups && proposal.tax) || proposal.salesTax)
                ? {
                    key: translate('tax_amount', { namespace }),
                    value: formatCurrency(proposal.subTotal *
                        (proposal.enableTaxGroups
                            ? parseFloat((_f = (_e = proposal.tax) === null || _e === void 0 ? void 0 : _e.rate) !== null && _f !== void 0 ? _f : '0') / 100
                            : ((_g = proposal.salesTax) !== null && _g !== void 0 ? _g : 0) / 100)),
                    type: IKeyValueType.text
                }
                : undefined,
            proposal.totalAmount !== undefined
                ? {
                    key: translate('total_amount', { namespace }),
                    value: formatCurrency(proposal.totalAmount),
                    type: IKeyValueType.text,
                    highlight: true
                }
                : undefined
        ].filter(Boolean),
        contactInfo: [
            {
                key: translate('primary_contact', { namespace }),
                value: (_j = (_h = proposal.preparedFor) === null || _h === void 0 ? void 0 : _h.name) !== null && _j !== void 0 ? _j : '',
                type: IKeyValueType.text,
                editable: true,
                field: 'preparedFor.name'
            },
            {
                key: translate('email', { namespace }),
                value: (_l = (_k = proposal.preparedFor) === null || _k === void 0 ? void 0 : _k.email) !== null && _l !== void 0 ? _l : '',
                type: IKeyValueType.text,
                editable: true,
                field: 'preparedFor.email'
            },
            {
                key: translate('cell_phone', { namespace }),
                value: (_o = (_m = proposal.preparedFor) === null || _m === void 0 ? void 0 : _m.phone) !== null && _o !== void 0 ? _o : '',
                type: IKeyValueType.phone,
                editable: true,
                field: 'preparedFor.phone'
            }
        ].filter(Boolean)
    };
}
